const actions = {
  async finishOnboarding({commit }) {

    const that = this._vm;
    const url = "v1/user/onboarding-completed";

    try {
      await that.$constants('$http').post(url);

    } catch (error) {

      const notification = {
        code: "urgent",
        title: "An error occurred during onboarding completed.Please refresh the page and try again."
      };
      commit("notifications/setNotification", notification, { root: true });

    }
  }
};

export default actions



// WEBPACK FOOTER //
// ./src/store/modules/onboarding/actions.js